import integrations from './integrations';

export default integrations;
